import axios, { AxiosPromise } from 'axios';

const stahnoutPdfSpravce = (id: string): AxiosPromise<{ redirect: string }> => {
    return axios({
        method: 'GET',
        url: `Spravceuctu/${id}/PreparePDF`
    });
};

export default stahnoutPdfSpravce;
